/* Warehouse catalog: quick filter + column sorting for [data-wh-table] tables. */
(function () {
  function normalize(value) {
    return (value || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function applyFilter(input) {
    var table = document.getElementById(input.getAttribute('data-wh-filter'));
    if (!table) return;
    var terms = normalize(input.value).split(/\s+/).filter(Boolean);
    var visible = 0;
    table.querySelectorAll('tbody tr').forEach(function (row) {
      var haystack = normalize(row.getAttribute('data-search'));
      var match = terms.every(function (t) { return haystack.indexOf(t) !== -1; });
      row.hidden = !match;
      if (match) visible++;
    });
    var empty = table.parentElement.querySelector('.wh-table__empty');
    if (empty) empty.hidden = visible !== 0;
  }

  function sortTable(button) {
    var table = button.closest('table');
    var key = button.getAttribute('data-sort-key');
    var numeric = button.hasAttribute('data-sort-numeric');
    var cell = button.closest('th');
    var direction = cell.getAttribute('aria-sort') === 'ascending' ? 'descending' : 'ascending';

    table.querySelectorAll('thead th').forEach(function (th) { th.removeAttribute('aria-sort'); });
    cell.setAttribute('aria-sort', direction);

    var body = table.tBodies[0];
    var rows = Array.prototype.slice.call(body.rows);
    var collator = new Intl.Collator(document.documentElement.lang || 'hr', { numeric: true, sensitivity: 'base' });
    rows.sort(function (a, b) {
      var x = a.getAttribute('data-' + key) || '';
      var y = b.getAttribute('data-' + key) || '';
      var result = numeric ? (parseFloat(x) || 0) - (parseFloat(y) || 0) : collator.compare(x, y);
      return direction === 'ascending' ? result : -result;
    });
    rows.forEach(function (row) { body.appendChild(row); });
  }

  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-wh-filter]')) applyFilter(event.target);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.wh-sort');
    if (button) sortTable(button);
  });
})();
